import React, { Component, Fragment } from 'react';
import { observer, inject } from 'mobx-react';
import { withRouter } from "react-router";
import ImgView from 'components/common/FileController/ImgView';
import { notification, Table, Input, Modal } from 'antd';
import PaginationComp from  'components/common/PaginationComp';

@inject('commonStore', 'goodsInfoStore')
@observer
class GoodsModal extends Component {
  state = {
    inputGdNm: '',

    selectedRowKeys: [],
    selectedRows: []
  };
  
  UNSAFE_componentWillMount() {
    this.props.goodsInfoStore.setCommonStoreInfo(this.props.commonStore);
    this.props.goodsInfoStore.onClear();
    this.props.goodsInfoStore.disGoodsList(1, 5);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.modalOpen !== this.props.modalOpen && nextProps.modalOpen === true) {
      this.setState({ 
        inputGdNm: '',

        selectedRowKeys: [],
        selectedRows: []
      });
      this.props.goodsInfoStore.disGoodsList(1);
    }
  }

  onPageChange = (pageIdx) => {
    // console.log('page:', pageIdx);
    this.props.goodsInfoStore.disGoodsList(pageIdx);
    this.setState({
      selectedRowKeys: [],
      selectedRows: []
    });
  };

  onSearch = () => {
    this.props.goodsInfoStore.onChangValue('gdNm', this.state.inputGdNm);
    this.props.goodsInfoStore.disGoodsList(1);
  };

  onPressEnter = (e) => {
    if (e.key === 'Enter') {
      this.onSearch();
    }
  };

  render() {
    const { goodsList, pageInfo} = this.props.goodsInfoStore;
    const {
      inputGdNm,

      selectedRowKeys,
      selectedRows
    } = this.state;
    const columns = [
      { title: 'No', dataIndex: 'RNUM', width: '7%', align: 'center' },
      { title: '사진', dataIndex: 'imgUrl', width: '16%', align: 'center',
        render: (_, record) => { return(
          record?.gdImgUrlInfo_fileId &&
          <ImgView
            fileInfo={{
              fileId: record.gdImgUrlInfo_fileId,
              fileName: record.gdImgUrlInfo_fileName,
              physicalName: record.gdImgUrlInfo_physicalName,
              serverSubPath: record.gdImgUrlInfo_serverSubPath,
            }}
            width={50}
            height={50}
          />
        )}
      },
      { title: '상품명', dataIndex: 'gdNm', width: '40%', align: 'center' },
      { title: '성별', dataIndex: 'gdSex', width: '15%', align: 'center',
        render: (item) => { return(
          <Fragment>
            {item === "M" && <Fragment>남</Fragment>}
            {item === "F" && <Fragment>여</Fragment>}
            {item === "A" && <Fragment>공용</Fragment>}
          </Fragment>
        )}
      },
      { title: '판매가', dataIndex: 'gdPrice', width: '20%', align: 'center',
        render: (item) => { return(
          <Fragment>
            {item !== undefined && item !== null && item !== "" && item.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
          </Fragment>
        )}
      }
    ];

    const rowSelection = {
      columnWidth: '2%',
      selectedRowKeys,
      onChange: (selectedRowKeys, selectedRows) => {
        //console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
        this.setState({selectedRowKeys, selectedRows});
      }
    };

    return (
      <Modal
        width={600}
        title="상품선택"
        cancelText={"취소"}
        okText={"확인"}
        closable={false}
        visible={this.props.modalOpen}
        onCancel={this.props.modalClose}
        onOk={()=>{
          if (selectedRows.length > 0) {
            this.props.setData(selectedRows);
            this.props.modalClose();
          } else {
            notification.warning({placement: 'bottomLeft', message: `상품을 선택해주세요.`, duration: 2});
          }
        }}
      > 
        상품명 : 
        <Input.Search
          placeholder="상품명을 입력하세요"
          value={inputGdNm}
          onChange={(e)=>this.setState({inputGdNm: e.target.value})}
          onPressEnter={this.onPressEnter}
          onSearch={this.onSearch}
          style={{ width: 200, marginBottom: 8 }}
        />

        <Table
          rowKey={(record)=>record.RNUM}
          columns={columns} 
          dataSource={goodsList}
          pagination={false}
          rowSelection={rowSelection}
        />
        <PaginationComp 
          pageInfo={pageInfo}
          onChange={this.onPageChange}
        />
      </Modal>
    );
  }

}

export default withRouter(GoodsModal);
